import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { useTheme } from '../../../theming/useTheme';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { OnTopCard } from '../../partials/cards/onTopCard/OnTopCard';
import { HorizontalCard } from '../../partials/cards/horizontalCard/HorizontalCard';
import { VerticalCard } from '../../partials/cards/verticalCard/VerticalCard';
import { BaseUnit } from '../../../theming/baseUnitDefinition';
import { createImageWidths } from '../../partials/image/image.utils';
import { CardComponentDataProps } from '../../partials/cards/cards.utils';

const numOnTop = 4;
const numHorizontal = 8;
const numVertical = 4;

interface AuthorPageFeedDataProps {
  articles: Array<CardComponentDataProps>;
}

const getStyles = (baseUnit: BaseUnit) => StyleSheet.create({
  wrapper: {
    maxWidth: '640px',
    margin: 'auto',
    display: 'grid',
    gridTemplateColumns: '1fr',
    marginTop: `${baseUnit}px`,
    gridRowGap: `${baseUnit}px`,
  },
});

const imageWidthsOnTopCard = createImageWidths(540, 1080, 1080);
const imageWidthsHorizontalCard = createImageWidths(360, 360, 360);
const imageWidthsVerticalCard = createImageWidths(540, 1080, 1080);

const arrangeCards = (articles: Array<CardComponentDataProps>) => {
  const structure = [numOnTop, numHorizontal, numVertical];
  let section = 0;
  let counter = 0;
  return articles.reduce((acc: any[], article: CardComponentDataProps) => {
    let Component;

    switch (section) {
      case 0:
        Component = <OnTopCard key={article.id} {...article} imageWidths={imageWidthsOnTopCard} />;
        break;
      case 1:
        Component = <HorizontalCard key={article.id} {...article} imageWidths={imageWidthsHorizontalCard} />;
        break;
      case 2:
        Component = <VerticalCard key={article.id} {...article} imageWidths={imageWidthsVerticalCard} />;
        break;
      default:
        Component = null;
        break;
    }

    counter += 1;
    if (counter >= structure[section]) {
      counter = 0;
      section = section === structure.length - 1 ? 0 : section + 1;
    }

    return [...acc, Component];
  }, []);
};

export const AuthorPageFeed: React.FunctionComponent<AuthorPageFeedDataProps> = props => {
  const { baseUnit } = useTheme();
  const { articles } = props;
  const styles = getStyles(baseUnit);
  return (
    <ErrorBoundary>
      {articles.length > 0
      && <div className={css(styles.wrapper)}>{arrangeCards(articles)}</div> }
    </ErrorBoundary>
  );
};
